<ng-template [ngIf]="isOfferScreenMapped">
  <div class="rightPannelBox">
    <div class="fltpanIn">
      <div class="float-right">
        <button (click)="offerPriceScreenCloseClick()" class="ba-btn ba-btn-sq-sm" role="button"><i
            class="fa fa-times"></i></button>
      </div>
      <div class="row mb-10">
        <div class="col-sm-4 pl-0">
          <h2>Offer Price</h2>
        </div>
        <div class="col-sm-7">
          <div class="row hidden-md hidden-sm hidden-xs">
            <div class="col-md-3 sml gry">Offer Expiration</div>
            <div class="col-md-4 sml gry">Price Gurantee Expiration</div>
            <div class="col-md-3 sml gry">PaymentTime Limit</div>
          </div>
          <div class="row hidden-md hidden-sm hidden-xs">
            <div class="col-md-3 sml gry">
              <span>{{ offerPriceScreen.offerPrice.offerExpiration | date : 'dd-MMM-YYYY hh:mm' : 'UTC +00:00' }}</span>
            </div>
            <div class="col-md-4 sml gry">
              <span>{{ offerPriceScreen.offerPrice.priceGuranteeExpiration | date : 'dd-MMM-YYYY h:mm' : 'UTC +00:00' }}
              </span>
            </div>
            <div class="col-md-3 sml gry">
              <span>{{ offerPriceScreen.offerPrice.paymentLimitTime | date : 'dd-MMM-YYYY h:mm' : 'UTC +00:00' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card pt-2 pb-1">
        <ng-template class="mt-2 mb-2" [ngIf]="offerPriceScreen.offerPrice!.boundAirlineOffer.length > 0">
          <div
            *ngFor="let boundAirlineOffers of offerPriceScreen.offerPrice!.boundAirlineOffer; let boundOfferIndex = index; let boundOfferLastIndex = last; let boundOfferFirstIndex = first">
            <div
              *ngFor="let flightDetail of boundAirlineOffers.flightDetails; let flightDetailIndex = index; let flightLastIndex = last; let flightFirstIndex = first">
              <div class="row air-offer" [class.mb-2]="boundOfferFirstIndex && boundOfferIndex !== 0"
                [class.mt-2]="boundOfferLastIndex && boundOfferIndex !== 0">
                <div class="row od2 ml-3">
                  <div class="col-md-9 right-dashed-border">
                    <div class="row">
                      <div class="col-sm-1">
                        <img *ngIf="getFlightLogoUrl(flightDetail.airlineName) !== ''" class="pt-10"
                          [src]="getFlightLogoUrl(flightDetail.airlineName)" />
                      </div>

                      <div class="col-sm-2">
                        <div class="flt-date">{{ flightDetail.departureDate }}</div>
                      </div>
                      <div class="col-sm-2">
                        <div>
                          <div class="fl-time">{{ flightDetail.departureTimeIn24H }}</div>
                          <div class="fl-airpt">
                            <div class="sm-text">{{ flightDetail.departureAirportName }}</div>
                            {{ flightDetail.departureAirportCode }}
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div style="text-align: center">
                          <span style="font-size: 12px"> {{ flightDetail.duriation }} </span>
                          <ul class="Leg-line"></ul>
                          <span style="font-size: 12px; color: #074e11">
                            {{ flightDetail.airlineId }}{{ flightDetail.airlineNumber }} | {{ flightDetail.economyCode
                            }}
                            |
                            {{ flightDetail.priceClassCode }}
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-2">
                        <div class="fl-time">{{ flightDetail.arrivalTimeIn24H }}</div>
                        <div class="fl-airpt">
                          <div class="sm-text">{{ flightDetail.arrivalAirportName }}</div>
                          {{ flightDetail.arrivalAirportCode }}
                        </div>
                      </div>

                      <!-- baggs icon -->
                      <div class="col-sm-2 iconsStatus">
                        <div class="mb-3">
                          <span class="pad-title">{{ flightDetail.economyTypeLabel }} </span><br />
                          <span class="pad-title">{{ flightDetail.economyType }} </span><br />
                        </div>

                        <!-- rulesref iconsss -->
                        <i *ngIf="flightDetail.iconsStatus?.baChangesFee === 'true'" class="baIcn ba-changes-fee ba-1x"
                          title="Changes Permitted with a Fee"></i>
                        <i *ngIf="flightDetail.iconsStatus?.baChangesFee === 'false'" class="baIcn ba-history ba-1x"
                          title="Change Time/Date Permitted"></i>
                        <i *ngIf="flightDetail.iconsStatus?.baRefund === 'true' && flightDetail.iconsStatus?.cancelFee === 'true'"
                          class="baIcn ba-refund ba-1x rfndGreen" title="Cancel Fee"></i>
                        <i *ngIf="flightDetail.iconsStatus?.cancelFee === 'false' && flightDetail.iconsStatus?.baRefund === 'true'"
                          class="baIcn ba-refund ba-1x rfndGreen" title="Refundable"></i>
                        <i *ngIf="flightDetail.iconsStatus?.remark === 'No changes permitted. No upgrades permitted'"
                          class="baIcn ba-airplane-cancel red ba-1x" title="Changes Not Permitted"></i>
                        <i *ngIf="flightDetail.iconsStatus?.baRefund === 'false'" class="baIcn ba-norefund ba-1x red"
                          title="Non Refundable"></i><br />

                        <div data-bs-toggle="dropdown">
                          <i class="baIcn ba-handbag ba-2x ba-mg-2 cursor" title="Handbag"></i>
                          <span *ngFor="let carryOnBagCount of flightDetail.iconsStatus?.baCarryOnBagCount">
                            <i *ngIf="flightDetail.iconsStatus?.baCarryOnBag"
                              class="cursor baIcn ba-carryOn-bag ba-3x ba-mg-2" title="Carry-On Bag"></i>
                          </span>
                          <span *ngFor="let carryOnBagCount of flightDetail.iconsStatus?.baCheckBagCount">
                            <i *ngIf="flightDetail.iconsStatus?.baCheckBag" class="cursor baIcn ba-check-bag ba-3x"
                              title="Checked In Bag "></i>
                          </span>
                        </div>

                        <!-- rulesref iconsss -->
                        <div class="webui-popover-inner dropdown-menu">
                          <a href="#" class="close"></a>
                          <div class="webui-arrow"></div>
                          <h3 class="webui-popover-title">Baggage Allowance</h3>
                          <div class="webui-popover-content">
                            <div>
                              <div class="row">
                                <div class="col-sm-3">
                                  <i class="baIcn ba-handbag ba-38x ba-mg-2" title="Handbag"></i>
                                </div>
                                <div class="col-sm-8">
                                  <span>Hand bag</span><br />
                                  1 x 23 Kg <br />
                                  {{ flightDetail.baggagePieceDimension?.handbagLength }} cm x {{
                                  flightDetail.baggagePieceDimension?.handbagHeight }} cm x
                                  {{ flightDetail.baggagePieceDimension?.handbagWidth }} cm
                                </div>
                              </div>
                              <div class="row" class="row"
                                *ngFor="let carryOnBagCount of flightDetail.iconsStatus?.baCarryOnBagCount">
                                <div class="col-sm-3">
                                  <i class="baIcn ba-carryOn-bag ba-4x ba-mg-2" title="Carry On Bag"></i>
                                </div>
                                <div class="col-sm-8">
                                  <span>{{ flightDetail.baggagePieceDimension?.baggageCategory }} Bag</span><br />
                                  1 x 23 Kg <br />
                                  {{ flightDetail.baggagePieceDimension?.bagLength }} cm x {{
                                  flightDetail.baggagePieceDimension?.bagHeight }} cm x
                                  {{ flightDetail.baggagePieceDimension?.bagWidth }} cm
                                </div>
                              </div>
                              <div class="row"
                                *ngFor="let baCheckBagCount of flightDetail.iconsStatus?.baCheckBagCount; let i = index">
                                <div class="col-sm-3">
                                  <i class="baIcn ba-check-bag ba-5x" title="Checked In Bag"></i>
                                </div>
                                <div class="col-sm-8">
                                  <span>Checked Baggage</span><br />
                                  {{ flightDetail.baggagePieceDimension?.quantity }} x {{
                                  flightDetail.baggagePieceDimension?.bagWeight }} Kg<br />
                                  90 cm x 43cm x 75 cm
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- pop up -->
                      </div>
                      <!-- bags icon -->
                    </div>
                    <!-- outbound rules -->
                    <div class="small-text col-sm-12 pl-0">Operated by {{ flightDetail.operatingCarrier }}</div>
                    <div id="main">
                      <div class="accordion" id="faq">
                        <div id="faqhead1">
                          <a href="#" class="btn-header-link" [class.collapsed]="!boundAirlineOffers.displayRule"
                            (click)="toggleRule(boundOfferIndex)">
                            <span class="pl-2">Rules</span>
                          </a>
                        </div>
                        <ng-template [ngIf]="boundAirlineOffers.displayRule">
                          <div class="srchODpn mb-3">
                            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                              <li class="nav-item" role="presentation">
                                <a class="nav-link active" id="pills-home-tab" data-bs-toggle="pill"
                                  [href]="'#pills-home' + boundOfferIndex" role="tab" aria-controls="pills-home"
                                  aria-selected="true">
                                  Pre Departure
                                </a>
                              </li>
                              <li class="nav-item" role="presentation">
                                <a class="nav-link ml-2" id="pills-profile-tab" data-bs-toggle="pill"
                                  [href]="'#pills-profile' + boundOfferIndex" role="tab" aria-controls="pills-profile"
                                  aria-selected="false">
                                  Post Departure
                                </a>
                              </li>
                              <li class="nav-item" role="presentation">
                                <a class="nav-link ml-2" id="pills-contact-tab" data-bs-toggle="pill"
                                  [href]="'#pills-contact' + boundOfferIndex" role="tab" aria-controls="pills-contact"
                                  aria-selected="false">
                                  No Show
                                </a>
                              </li>
                            </ul>
                            <div class="tab-content" id="pills-tabContent">
                              <div class="tab-pane fade show active" [attr.id]="'pills-home' + boundOfferIndex"
                                role="tabpanel" aria-labelledby="pills-home-tab">
                                <div *ngFor="let rule of boundAirlineOffers.preDepatureRules" class="pl-2">
                                  <div>{{ rule.changeRuleLable | uppercase }}</div>
                                  <div>
                                    {{ rule.changePenaltyRemark }} <b>{{ rule.changePenaltyAmount }}</b>
                                  </div>
                                  <div>{{ rule.cancellationRuleLabel | uppercase }}</div>
                                  <div>
                                    {{ rule.cancellationPenaltyRemark }} <b>{{ rule.cancellationPenaltyAmount }}</b>
                                  </div>
                                </div>
                              </div>
                              <div class="tab-pane fade p-2" [attr.id]="'pills-profile' + boundOfferIndex"
                                role="tabpanel" aria-labelledby="pills-profile-tab">
                                <div *ngFor="let rule of boundAirlineOffers.postDepatureRules" class="pl-2">
                                  <div>{{ rule.changeRuleLable | uppercase }}</div>
                                  <div>
                                    {{ rule.changePenaltyRemark }} <b>{{ rule.changePenaltyAmount }}</b>
                                  </div>
                                  <div>{{ rule.cancellationRuleLabel | uppercase }}</div>
                                  <div>
                                    {{ rule.cancellationPenaltyRemark }} <b>{{ rule.cancellationPenaltyAmount }}</b>
                                  </div>
                                </div>
                              </div>
                              <div class="tab-pane fade p-2" [attr.id]="'pills-contact' + boundOfferIndex"
                                role="tabpanel" aria-labelledby="pills-contact-tab">
                                <div *ngFor="let rule of boundAirlineOffers.noShowRules" class="pl-2">
                                  <div>{{ rule.changeRuleLable | uppercase }}</div>
                                  <div>
                                    {{ rule.changePenaltyRemark }} <b>{{ rule.changePenaltyAmount }}</b>
                                  </div>
                                  <div>{{ rule.cancellationRuleLabel | uppercase }}</div>
                                  <div>
                                    {{ rule.cancellationPenaltyRemark }} <b>{{ rule.cancellationPenaltyAmount }}</b>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                    <!-- outbound rules -->
                  </div>
                  <div class="col-md-3 posRelative">
                    <ng-template [ngIf]="boundOfferFirstIndex && flightFirstIndex">
                      <div class="upPatch"></div>
                    </ng-template>


                    <button *ngIf="!isSMEUser" type="button" role="button"
                      (click)="manageSeats(flightDetailIndex, boundOfferIndex)"
                      class="ba-btn ba-btn-smx-vthin ba-btn-w90">
                      Add <i class="baIcn ba-flight-seat ba-seat2x"></i>
                    </button>

                    <ng-template [ngIf]="boundOfferLastIndex && flightLastIndex">
                      <div class="downPatch-outbound"></div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <!-- outbound airline offers -->
        <!--price-->
        <div class="flPriceUI">
          <div class="flPriceWrapper">
            <div class="flPrice">{{ roundOfferPrice(offerPriceScreen.offerPrice.priceDetail.price) }}</div>
            <div>
              <span class="sm-cur mt-4">{{ offerPriceScreen.offerPrice.priceDetail.currency }}</span>
            </div>
          </div>
        </div>
        <!--end-->
        <!-- inbound airline offers -->

      </div>

      <!-- Upsell Offers Starts-->
      <ng-container *ngIf="availableOtherOffers.length>0">
        <details class="mt-3">
          <summary>
            <h3>Upsell Offers</h3>
          </summary>
          <ng-container *ngFor="let otheroffer of availableOtherOffers; let i=index">
            <div class="row m-1">
              <div class="upgradeOffer col-lg-12">

                <h6 class="col">Upgrade Offer / Booking</h6>

                <div class="free col">
                  <span>
                    <details>
                      <summary>
                        {{otheroffer.economyTypeName | titlecase}}
                      </summary>
                      <ng-container *ngFor="let description of otheroffer.priceClassDescriptions">
                        <div class="mt-2">
                          {{description.TEXT[0] | titlecase}}
                        </div>
                      </ng-container>
                    </details>
                  </span>
                </div>
                <div class="oldprice col">
                  Old Price {{offerPriceScreen.offerPrice.priceDetail.price}}
                  {{offerPriceScreen.offerPrice.priceDetail.currency}}
                </div>
                <div class="newTotal col"> New Price {{otheroffer.price}} {{otheroffer.currency}}</div>

                <a class="upgrade col" href="#" (click)="selectOtherOffer(i)">
                  <h6>Upgrade with {{pricedifference(otheroffer.price, offerPriceScreen.offerPrice.priceDetail.price)}}
                    {{otheroffer.currency}}</h6>
                </a>

              </div>
            </div>
          </ng-container>
        </details>
      </ng-container>
      <!-- Upsell Offers End-->

      <div class="mt-5 ml-2">
        <app-passenger-details></app-passenger-details>
      </div>

      <ng-template [ngIf]="displayConfirmBookingScreen">
        <div id="pnsvl">
          <div id="paypn" class="mt-10">
            <div>
              <app-confirm-booking-screen></app-confirm-booking-screen>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>